import AntdRow      from 'antd/lib/row';
import React        from 'react';
import useDashboard from '@widesk-ui/hooks/useDashboard';
import { Col }      from '@widesk-ui/components/Col';
import { Gutter }   from 'antd/lib/grid/row';

type RowProps = {
	gutter?: Gutter | [Gutter, Gutter];
	children: React.ReactNode;
}

export default function Row(props: RowProps) {
	const { dashboardStore } = useDashboard();

	return (
		<AntdRow gutter={props.gutter || dashboardStore?.bodyGutter}>
			{props.children}
		</AntdRow>
	);
}

Row.Col = Col;
